import { render, staticRenderFns } from "./ViewWithLayout.vue?vue&type=template&id=6b9c2a12&scoped=true"
import script from "./ViewWithLayout.vue?vue&type=script&lang=js"
export * from "./ViewWithLayout.vue?vue&type=script&lang=js"
import style0 from "./ViewWithLayout.vue?vue&type=style&index=0&id=6b9c2a12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9c2a12",
  null
  
)

export default component.exports